export { default as AddBorrower } from './AddBorrower';
export { default as BorrowersList } from './BorrowersList';
export { default as BorrowerDetails } from './BorrowerDetails';
export { default as BorrowerCkr } from './BorrowerCkr';